import {
  createResource,
  postResource,
  putResource
} from '@resource/resource'

import { prefixAPI } from '@resource/api'

const LOGIN_LINK = prefixAPI('login/')
const CHANGE_PASSWORD = prefixAPI('password-change/')
const LOGOUT_LINK = prefixAPI('logout/')

export const loginResource = createResource(LOGIN_LINK, postResource)
export const passwordResource = createResource(CHANGE_PASSWORD, putResource)
export const logoutResource = createResource(LOGOUT_LINK, postResource)



// WEBPACK FOOTER //
// ./src/js/services/auth.js